import React, { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { Content, Header } from '@backstage/core-components';
import { FlexBox } from '../../global/FlexBox';
import { InvitationsGrid } from '../components/InvitationsGrid/InvitationsGrid';
import { useInvitationsPendingCount } from '../components/InvitationsGrid/useInvitationsPendingCount';
import {
  PageTitle,
  PendingCountChip,
} from '../components/InvitationsGrid/styles';
import { InviteMemberModal } from '../components/InviteMemberModal/InviteMemberModal';
import type { Invitation } from '../components/InvitationsGrid/types';

export default function InvitationsPage() {
  const [isInviteOpen, setIsInviteOpen] = useState(false);
  const [visibleInvitations, setVisibleInvitations] = useState<
    readonly Invitation[]
  >([]);
  const pendingCountQuery = useInvitationsPendingCount();
  const pendingCount = pendingCountQuery.data?.total ?? 0;

  return (
    <>
      <Header
        pageTitleOverride="Invitations"
        title={
          <FlexBox sx={{ justifyContent: 'space-between', width: '100%' }}>
            <PageTitle>
              <Typography variant="h4">Invitations</Typography>
              {pendingCount > 0 && (
                <PendingCountChip color="primary" label={pendingCount} />
              )}
            </PageTitle>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setIsInviteOpen(true)}
            >
              Invite New Member
            </Button>
          </FlexBox>
        }
        subtitle="Manage pending and rejected invites"
      />
      <Content>
        <InvitationsGrid onInvitationsChange={setVisibleInvitations} />
      </Content>
      <InviteMemberModal
        isOpen={isInviteOpen}
        onClose={() => setIsInviteOpen(false)}
        invitations={visibleInvitations}
      />
    </>
  );
}
